import { render, staticRenderFns } from "./ClaimTypeTile.vue?vue&type=template&id=5fbd9738"
import script from "./ClaimTypeTile.vue?vue&type=script&lang=ts"
export * from "./ClaimTypeTile.vue?vue&type=script&lang=ts"
import style0 from "./ClaimTypeTile.vue?vue&type=style&index=0&id=5fbd9738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports